import * as React from 'react';
import {PlanFormComponent} from '../../../components/plans/PlanFormComponent';
import {PlanContextProvider} from '../../../context/PlanContext';
import Breadcrumb from '../../../components/Breadcrumb';
import { zodResolver } from '@hookform/resolvers/zod';
import { PlanFormValues, PlanInterface, planFormSchema } from '../../../components/plans/PlanFormInfo.type';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { BILLING_TRIGGER } from '../../../components/plans/PlanFormInfo.use-case';

declare global {
  interface Window {
    account: string;
  }
}

interface PlanEditProps {
  plan: PlanInterface;
  action: string;
  programs: any[];
  externalStoreEnabled: boolean;
  externalStoreOptions: [string];
}

function PlanEdit({plan, action, programs, externalStoreEnabled, externalStoreOptions} : PlanEditProps) : JSX.Element {
  document.title = `${window.account}/planos/${plan.code}`;

  const BreadcumbsData = [
    {
      url: null,
      icon: 'cog',
      label: 'Configurações',
    },
    {
      url: `/${window.account}/admin/plans/`,
      label: 'Planos',
    },
    {
      label: plan.name,
      url: null
    }
  ]

  if(action === 'new'){
    BreadcumbsData.pop();
    BreadcumbsData.push({
      label: 'Novo plano',
      url: null
    });
  }
  const form = useForm<PlanFormValues>({
    resolver: zodResolver(planFormSchema),
    mode: 'onChange',
    defaultValues: {
      name: plan?.name || '',
      description: plan?.description || '',
      planType: plan?.planType || 'normal',
      visibility: plan?.visibility || 'everywhere',
      color: plan?.color || '',
      coverUrl: plan?.coverUrl || '',
      billingTriggerType: plan?.billingTriggerType || BILLING_TRIGGER[0].value,
      planPrograms: (plan?.planPrograms || [])
        .filter((pp: any) => !!pp && !!pp?.filial)
        .map((pp: any) => ({value: `${pp.programId}`, label: `${pp.name} (${pp.filial.name})`})) || [],
      externalPlans: (plan?.externalPlans || [])
        .map((ep: any) => ({label: ep.store, value: ep.store})) || [],
      recurrence: plan?.recurrence || '',
      recurrenceValue: plan?.recurrenceValue?.toString() || '',
      value: plan?.value?.toString() || '',
      installments: plan?.installments?.toString() || ''
    }
  });

  return(
    <FormProvider {...form}>
      <PlanContextProvider plan={plan} programs={programs} externalStoreEnabled={externalStoreEnabled} externalStoreOptions={externalStoreOptions}>
        <div className="row">
          <div className="col s12">
            <Breadcrumb data={BreadcumbsData} />
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            {action === 'new' ? <h1>Novo plano</h1> : <h1>{plan.name}</h1>}
          </div>
        </div>
        <PlanFormComponent />
      </PlanContextProvider>
    </FormProvider>
  )
}

export default PlanEdit;